export enum EDirection {
  LTR = 'ltr',
  RTL = 'rtl',
}

let fontClassName = 'font-ltr';
let documentDirection = EDirection.LTR;

export const DirectionService = {
  set: (direction: EDirection) => {
    documentDirection = direction;
    document.documentElement.style.setProperty('--direction', direction);
    DirectionService.setFontClass(direction);
  },
  get: (): EDirection => documentDirection,
  setFontClass(direction: string) {
    const newFontClassName = `font-${direction}`;

    document.body.classList.remove(fontClassName);
    document.body.classList.add(newFontClassName);
    fontClassName = newFontClassName;
  },
};
